import * as offersActions from './actions';
import {Record, List, fromJS} from 'immutable';
import {getNameByLang} from '../lib/util';

const State = Record({
    offers: List(),
    offerName: '',
    openChangeOfferPopup: false
});

const OFFERS = 'offers';
const OFFER_NAME = 'offerName';

const offersReducer = (state = new State(), action) => {

    switch (action.type) {

        case offersActions.FETCH_OFFERS_SUCCESS: {
            return state.set(OFFERS, fromJS(action.payload.data));
        }

        case offersActions.CHOOSE_OFFER: {
            const index = state.get(OFFERS).findIndex(t =>
                t.get('id') === action.payload
            );
            return state
                .set(OFFER_NAME, getNameByLang(state.getIn([OFFERS, index])));
        }
    }

    return state;
};

export default offersReducer;



// WEBPACK FOOTER //
// ./src/common/offers/reducer.js